import { jsx as _jsx } from "react/jsx-runtime";
import { SpecraCombobox } from '@mono/ui-components';
import { useState } from 'react';
import { formatGovernmentOrgLabel, useGovernmentOrganizations } from '../../pages/Delivery/Programs/referenceDataHooks';
/**
 * "Find in registry" helper for free-text agency fields: search the gov-org registry and
 * write the picked organization's name into the field. The field keeps storing text, so
 * nothing that reads it changes.
 */ export function AgencyNamePicker({ onPick, label = 'Find in registry', disabled }) {
    const [query, setQuery] = useState('');
    const orgs = useGovernmentOrganizations({
        search: query,
        enabled: query.trim().length > 1
    });
    const options = (orgs.data ?? []).slice(0, 30).map((o)=>({
            value: o.id,
            label: o.name,
            description: formatGovernmentOrgLabel(o)
        }));
    return /*#__PURE__*/ _jsx(SpecraCombobox, {
        label: label,
        placeholder: "Find an agency or office in the registry",
        searchPlaceholder: "Agency, office or code",
        emptyMessage: query.trim().length > 1 ? 'No registry organization matches.' : 'Type to search.',
        loading: orgs.isFetching,
        shouldFilter: false,
        searchValue: query,
        onSearchValueChange: setQuery,
        options: options,
        value: undefined,
        disabled: disabled,
        onOptionChange: (o)=>{
            if (o && typeof o.label === 'string') onPick(o.label);
        }
    });
}
